module.exports = __webpack_public_path__ + "static/media/IR.fe2bda23.png";